import React, { useEffect, useState } from "react";
import {
  verifyPasswordResetCode,
  confirmPasswordReset,
  getAuth,
} from "firebase/auth";
import { useNavigate } from "react-router-dom";
import "./Login.css";

function ResetPasswordPage() {
  const auth = getAuth();

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const params = new URLSearchParams(window.location.search);
  const oobCode = params.get("oobCode");

  useEffect(() => {
    if (!oobCode) {
      setMessage("❌ Link non valido.");
      return;
    }

    verifyPasswordResetCode(auth, oobCode)
      .catch(() => {
        setMessage("❌ Link scaduto o non valido.");
      });

  }, [auth, oobCode]);

  const handleReset = async (e) => {
    e.preventDefault();

    if (password.length < 6) {
      setMessage("⚠️ Minimo 6 caratteri.");
      return;
    }

    if (password !== confirm) {
      setMessage("⚠️ Le password non coincidono.");
      return;
    }

    try {
      setLoading(true);

      await confirmPasswordReset(auth, oobCode, password);

      setSuccess(true);
      setMessage("✅ Password aggiornata con successo.");

      setTimeout(() => {
        navigate("/login");
      }, 2500);

    } catch (err) {
      console.error(err);
      setMessage("❌ Errore durante il reset.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="login-card">

        <div className="brand">
          <div className="logo-icon">
            <img src="/logo-quadrato.png" alt="QrMenu" />
          </div>
          <h1>QrMenu</h1>
        </div>

        <p className="subtitle">
          {success
            ? "Password aggiornata"
            : "Reimposta la tua password"}
        </p>

        {!success && (
          <form onSubmit={handleReset} className="login-form">

            <div className="input-group">
              <label>Nuova password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Nuova password"
                required
              />
            </div>

            <div className="input-group">
              <label>Conferma password</label>
              <input
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                placeholder="Ripeti password"
                required
              />
            </div>

            <button className="primary-btn" disabled={loading}>
              {loading ? "Aggiornamento..." : "Aggiorna password"}
            </button>

          </form>
        )}

        {message && (
          <div className={success ? "success" : "error"}>
            {message}
          </div>
        )}

      </div>
    </div>
  );
}

export default ResetPasswordPage;